import { TableColumnsType } from 'antd';
import { EReportDataInterval, ILogReport } from '../types/report-log.type';
import {
  CLUTCH_OPERATION_MODE_KEYS,
  getPresentOperationModeKeys,
} from './helperFunction';
import { capitalizeFirstLetter } from '@qlibs/react-components';
import { DeviceProperties } from '../../device/types/device.type';
import { EAssetType } from '../../asset/types/asset.type';

const dataOptionTotalCruise = [
  {
    label: 'KM',
    value: 'KM',
  },
  {
    label: 'NM',
    value: 'NM',
  },
  {
    label: 'MILES',
    value: 'MILES',
  },
];

const dataOptionAverageSpeed = [
  {
    label: 'KNOT',
    value: 'KNOT',
  },
  {
    label: 'KM/H',
    value: 'KM/H',
  },
];

const columnGps = {
  title: 'GPS',
  key: 'gps',
  children: [
    {
      title: 'Coordinate',
      dataIndex: 'gps_coordinate',
      key: 'gps_coordinate',
      width: 180,
      align: 'center',
    },
    {
      title: 'Heading',
      dataIndex: 'gps_heading',
      key: 'gps_heading',
      width: 70,
      align: 'center',
    },
    {
      title: 'Speed',
      dataIndex: 'gps_speed',
      key: 'gps_speed',
      width: 100,
      align: 'center',
    },
    {
      title: 'Distance',
      dataIndex: 'gps_distance',
      key: 'gps_distance',
      width: 65,
      align: 'center',
    },
  ],
};

const columnChildrenFlowmeter = [
  {
    title: 'RPM',
    dataIndex: 'rpm',
    key: 'rpm',
    width: 80,
  },
  {
    title: 'Engine Status',
    dataIndex: 'engineStatus',
    key: 'engineStatus',
    width: 100,
  },
  {
    title: 'Ops. Mode',
    dataIndex: 'operationMode',
    key: 'operationMode',
    width: 100,
  },
  {
    title: 'Run. Time',
    dataIndex: 'runningTime',
    key: 'runningTime',
    width: 70,
  },
  {
    title: 'Fuel Cons. (Liter)',
    dataIndex: 'fuelCons',
    key: 'fuelCons',
    width: 80,
  },
  {
    title: 'Volume Total In (Liter)',
    dataIndex: 'volumeTotal',
    key: 'volumeTotal',
  },
  {
    title: 'In Flow',
    dataIndex: 'inFlow',
    key: 'inFlow',
    width: 100,
  },
  {
    title: 'In Temp. (°C)',
    dataIndex: 'temperature',
    key: 'temperature',
  },
  {
    title: 'In Density (g/m³)',
    dataIndex: 'inDensity',
    key: 'inDensity',
  },
];

const columnChildrenRPM = [
  {
    title: 'RPM',
    dataIndex: 'rpm',
    key: 'rpm',
    width: 80,
  },
  {
    title: 'Engine Status',
    dataIndex: 'engineStatus',
    key: 'engineStatus',
    width: 100,
  },
  {
    title: 'Ops. Mode',
    dataIndex: 'operationMode',
    key: 'operationMode',
    width: 100,
  },
  {
    title: 'Run. Time',
    dataIndex: 'runningTime',
    key: 'runningTime',
    width: 70,
  },
];

const columnChildrenClutch = [
  {
    title: 'Clutch',
    dataIndex: 'clutch',
    key: 'clutch',
    width: 80,
  },
  {
    title: 'Clutch Status',
    dataIndex: 'clutchStatus',
    key: 'clutchStatus',
    width: 100,
  },
  {
    title: 'Clutch Ops. Mode',
    dataIndex: 'clutchOperationMode',
    key: 'clutchOperationMode',
    width: 100,
  },
  {
    title: 'Clutch Run. Time',
    dataIndex: 'clutchRunningTime',
    key: 'clutchRunningTime',
    width: 70,
  },
];

const columnChildrenOperationMode = [
  {
    title: 'RPM',
    dataIndex: 'rpm',
    key: 'rpm',
    width: 80,
  },
  {
    title: 'MODE',
    dataIndex: 'mode',
    key: 'mode',
    width: 70,
  },
  {
    title: 'Fuel Cons. (Liter)',
    dataIndex: 'consRate',
    key: 'consRate',
    width: 80,
  },
];

const columnChildrenClutchOperationMode = [
  {
    title: 'Clutch',
    dataIndex: 'clutch',
    key: 'clutch',
    width: 80,
  },
  {
    title: 'Clutch Mode',
    dataIndex: 'mode',
    key: 'mode',
    width: 90,
  },
  {
    title: 'Clutch Fuel Cons. (Liter)',
    dataIndex: 'consRate',
    key: 'consRate',
    width: 90,
  },
];

const clutchOperationModeColumnGroups = [
  { key: 'clutchPort', title: 'CLUTCH PORT' },
  { key: 'clutchStarboard', title: 'CLUTCH STARBOARD' },
  { key: 'clutchCenter', title: 'CLUTCH CENTER' },
] as const;

const columnChildrenAE = [
  {
    title: 'Run. Time',
    dataIndex: 'runningTime',
    key: 'runningTime',
    width: 80,
  },
  {
    title: 'Fuel Cons.',
    dataIndex: 'fuelConsumption',
    key: 'fuelConsumption',
    width: 80,
  },
];

const columnChildrenAECustom = [
  {
    title: 'Run. Time',
    dataIndex: 'runningTime',
    key: 'runningTime',
    width: 80,
  },
  {
    title: 'Volume Total In (Liter)',
    dataIndex: 'volumeTotal',
    key: 'volumeTotal',
  },
  {
    title: 'In Flow',
    dataIndex: 'inFlow',
    key: 'inFlow',
    width: 100,
  },
  {
    title: 'In Temp. (°C)',
    dataIndex: 'temperature',
    key: 'temperature',
  },
  {
    title: 'In Density (g/m³)',
    dataIndex: 'inDensity',
    key: 'inDensity',
  },
];

const columnChildrenFlowmeterCustom = [
  {
    title: 'Volume Total In (Liter)',
    dataIndex: 'volumeTotal',
    key: 'volumeTotal',
  },
  {
    title: 'In Flow',
    dataIndex: 'inFlow',
    key: 'inFlow',
    width: 100,
  },
  {
    title: 'In Temp. (°C)',
    dataIndex: 'temperature',
    key: 'temperature',
  },
  {
    title: 'In Density (g/m³)',
    dataIndex: 'inDensity',
    key: 'inDensity',
  },
];

export const getDeviceType = (deviceUniqueId: string) => {
  const parts = deviceUniqueId.split('-');
  if (parts.length > 1) {
    if (parts[3]) {
      return `${parts[1]}-${parts[2]}-${parts[3]}`;
    } else if (parts[2]) {
      return `${parts[1]}-${parts[2]}`;
    } else {
      return parts[1];
    }
  }
  return null;
};

export const resolveSummaryColumns = (devices: { uniqueId: string }[]) => {
  let columnRPMPort = false;
  let columnRPMStarboard = false;
  let columnRPMCenter = false;
  let columnFlowmeterPort = false;
  let columnFlowmeterStarboard = false;
  let columnFlowmeterCenter = false;

  devices.forEach((device) => {
    const deviceType = getDeviceType(device.uniqueId);

    if (deviceType === 'fm-1' || deviceType?.startsWith('fm-1-')) {
      columnFlowmeterPort = true;
    }
    if (deviceType === 'fm-2' || deviceType?.startsWith('fm-2-')) {
      columnFlowmeterStarboard = true;
    }
    if (deviceType === 'fm-3' || deviceType?.startsWith('fm-3-')) {
      columnFlowmeterCenter = true;
    }

    if (deviceType === 'rpm-1') columnRPMPort = true;
    if (deviceType === 'rpm-2') columnRPMStarboard = true;
    if (deviceType === 'rpm-3') columnRPMCenter = true;
  });

  return {
    columnRPMPort,
    columnRPMStarboard,
    columnRPMCenter,
    columnFlowmeterPort,
    columnFlowmeterStarboard,
    columnFlowmeterCenter,
  };
};

export const renderAEKeyLabel = (splitIds: string[], type: 'title' | 'key') => {
  if (splitIds.length === 2) {
    return type === 'key' ? `ae${splitIds[1]}` : `AE ${splitIds[1]}`;
  } else {
    const flowType = splitIds[2] === '1' ? 'In' : 'Out';
    return type === 'key'
      ? `ae${splitIds[1]}${flowType}`
      : `AE ${splitIds[1]} ${flowType.toUpperCase()}`;
  }
};

export const renderFlowmeterKeyLabel = (splitIds: string[], type: 'title' | 'key') => {
  const flowType = splitIds[2] === '1' ? 'In' : 'Out';
  let position = '-'

  if (splitIds[1] === '1') {
    position = 'Port'
  } else if (splitIds[1] === '2') {
    position = 'Starboard'
  } else if (splitIds[1] === '3') {
    position = 'Center'
  }

  if (type === 'key') {
    return `fm${position}${flowType}`
  } else {
    return `FM ${position.toUpperCase()} ${flowType.toUpperCase()}`;
  }
};

export const generateReportLogColumns = (
  devices: DeviceProperties[],
  assetType: EAssetType,
  isOperationMode?: boolean,
) => {
  let columns: TableColumnsType<any> = [
    {
      title: 'Date & Time',
      dataIndex: 'dateTime',
      key: 'dateTime',
      width: 150,
      align: 'center',
      fixed: 'left',
    },
  ];

  let columnGpsDevice = false;
  let columnRPMPort = false;
  let columnRPMStarboard = false;
  let columnRPMCenter = false;
  let columnClutchPort = false;
  let columnClutchStarboard = false;
  let columnClutchCenter = false;
  let columnAEIds = [];
  let columnAE: any[] = [];
  let columnFlowmeterIds = [];
  let columnFlowmeter: any[] = [];
  let columnAe1Custom = false;
  let columnAe2Custom = false;
  let columnAe3Custom = false;
  
  for (let i = 0; i < devices.length; i++) {
    const device = devices[i];
    const deviceSplit = device.uniqueId.split('-');
    const deviceType =
      deviceSplit && deviceSplit.length > 0
        ? deviceSplit.slice(1, deviceSplit.length).join('-')
        : null;

    if (deviceType === 'gps') {
      columnGpsDevice = true;
    }

    if (deviceType?.includes('rpm-1')) {
      columnRPMPort = true;
    }

    if (deviceType?.includes('rpm-2')) {
      columnRPMStarboard = true;
    }

    if (deviceType?.includes('rpm-3')) {
      columnRPMCenter = true;
    }

    if (deviceType?.includes('clutch-1')) {
      columnClutchPort = true;
    }

    if (deviceType?.includes('clutch-2')) {
      columnClutchStarboard = true;
    }

    if (deviceType?.includes('clutch-3')) {
      columnClutchCenter = true;
    }

    if (deviceType?.includes('ae')) {
      columnAEIds.push(deviceType);
    }

    if (assetType === EAssetType.FMS && deviceType?.includes('fm')) {
      columnFlowmeterIds.push(deviceType);
    }
  }

  if (columnGpsDevice) {
    columns.push(columnGps);
  }

  const createEngineColumn = (
    position: string,
    label: string,
    hasRpm: boolean,
    hasClutch: boolean,
  ) => ({
    title: label,
    key: position,
    width: 400,
    children: [
      ...(hasRpm
        ? columnChildrenRPM
            .filter((item) =>
              !isOperationMode ? item.dataIndex !== 'operationMode' : true,
            )
            .map((item) => ({
              ...item,
              align: 'center',
              width: item.width || 100,
              dataIndex:
                position + '_' + capitalizeFirstLetter(item.dataIndex),
              key: position + '_' + capitalizeFirstLetter(item.key),
            }))
        : []),
      ...(hasClutch
        ? columnChildrenClutch.map((item) => ({
            ...item,
            align: 'center',
            width: item.width || 100,
            dataIndex:
              position + '_' + capitalizeFirstLetter(item.dataIndex),
            key: position + '_' + capitalizeFirstLetter(item.key),
          }))
        : []),
    ],
  });

  if (columnRPMPort || columnClutchPort) {
    columns.push(
      createEngineColumn('port', 'PORT', columnRPMPort, columnClutchPort),
    );
  }

  if (columnRPMStarboard || columnClutchStarboard) {
    columns.push(
      createEngineColumn(
        'starboard',
        'STARBOARD',
        columnRPMStarboard,
        columnClutchStarboard,
      ),
    );
  }

  if (columnRPMCenter || columnClutchCenter) {
    columns.push(
      createEngineColumn('center', 'CENTER', columnRPMCenter, columnClutchCenter),
    );
  }

  if (columnFlowmeterIds.length) {
    columnFlowmeterIds.forEach((columItem) => {
      const itemSplit = columItem.split('-');
      const title = renderFlowmeterKeyLabel(itemSplit, 'title');
      const key = renderFlowmeterKeyLabel(itemSplit, 'key');

      if (itemSplit.length === 3) {
        columnFlowmeter.push({
          title,
          key,
          children: columnChildrenFlowmeterCustom.map((item) => {
            return {
              ...item,
              align: 'center',
              width: item.width || 100,
              dataIndex: `${key}_${capitalizeFirstLetter(item.dataIndex)}`,
              key: `${key}_${capitalizeFirstLetter(item.dataIndex)}`,
            };
          }),
        });

        let position = '-'
        if (itemSplit[1] === '1') {
          position = 'Port'
        } else if (itemSplit[1] === '2') {
          position = 'Starboard'
        } else if (itemSplit[1] === '3') {
          position = 'Center'
        }

        const titleFuel = `FM ${position.toUpperCase()} Fuel Cons. (Liter)`;

        const keyFuel = `fm${position}`;
        const found = columnFlowmeter.find((item) => item.title === titleFuel);

        if (!found) {
          columnFlowmeter.push({
            title: titleFuel,
            align: 'center',
            dataIndex: `${keyFuel}_FuelConsumption`,
            key: `${keyFuel}_FuelConsumption`,
            width: 80,
          });
        }
      } else {
        columnFlowmeter.push({
          title,
          key,
          children: columnChildrenAE.map((item) => {
            return {
              ...item,
              align: 'center',
              width: item.width || 100,
              dataIndex: `${key}_${capitalizeFirstLetter(item.dataIndex)}`,
              key: `${key}_${capitalizeFirstLetter(item.dataIndex)}`,
            };
          }),
        });
      }
    });

    const columnFlowmeterSorted = columnFlowmeter.sort((a, b) => {
      const parseKey = (key: string) => {
        const matchInOut = key.match(/fm([a-zA-Z]+)(In|Out)/i);
        if (matchInOut) {
          return {
            position: matchInOut[1].toLowerCase(),
            type: matchInOut[2].toLowerCase(),
            order: 1,
          };
        }

        const matchFuel = key.match(/fm([a-zA-Z]+)_FuelConsumption/i);
        if (matchFuel) {
          return { 
            position: matchFuel[1].toLowerCase(), 
            type: 'fuel', 
            order: 2
          };
        }

        return { position: '', type: '', order: 99 };
      };

      const aVal = parseKey(a.key);
      const bVal = parseKey(b.key);

      const positionWeight: Record<string, number> = {
        port: 1,
        starboard: 2,
        center: 3,
      };
      
      const weightA = positionWeight[aVal.position] || 99;
      const weightB = positionWeight[bVal.position] || 99;
      
      if (weightA !== weightB) return weightA - weightB;

      if (aVal.order !== bVal.order) return aVal.order - bVal.order;

      if (aVal.type !== bVal.type) {
        if (aVal.type === 'in') return -1;
        if (bVal.type === 'in') return 1; 
      }

      return 0;
    });

    columns = [...columns, ...columnFlowmeterSorted];
  }

  if (
    assetType === EAssetType.FMS && columnFlowmeterIds.length
  ) {
    columns.push({
      title: 'ME Fuel Cons. (Liter)',
      dataIndex: 'meFuelCons',
      key: 'meFuelCons',
      align: 'center',
      width: 100,
    });
  }

  if (columnAEIds.length) {
    columnAEIds.forEach((columItem) => {
      const itemSplit = columItem.split('-');
      const title = renderAEKeyLabel(itemSplit, 'title');
      const key = renderAEKeyLabel(itemSplit, 'key');

      if (itemSplit.length === 3) {
        columnAE.push({
          title,
          key,
          children: columnChildrenAECustom.map((item) => {
            return {
              ...item,
              align: 'center',
              width: item.width || 100,
              dataIndex: `${key}_${capitalizeFirstLetter(item.dataIndex)}`,
              key: `${key}_${capitalizeFirstLetter(item.dataIndex)}`,
            };
          }),
        });

        const titleFuel = `AE ${itemSplit[1]} Fuel Cons. (Liter)`;
        const keyFuel = `ae${itemSplit[1]}`;
        const found = columnAE.find((item) => item.title === titleFuel);

        if (!found) {
          columnAE.push({
            title: titleFuel,
            align: 'center',
            dataIndex: `${keyFuel}_FuelConsumption`,
            key: `${keyFuel}_FuelConsumption`,
            width: 80,
          });
        }
      } else {
        columnAE.push({
          title,
          key,
          children: columnChildrenAE.map((item) => {
            return {
              ...item,
              align: 'center',
              width: item.width || 100,
              dataIndex: `${key}_${capitalizeFirstLetter(item.dataIndex)}`,
              key: `${key}_${capitalizeFirstLetter(item.dataIndex)}`,
            };
          }),
        });
      }
    });

    const columnAESorted = columnAE.sort((a, b) => {
      const parseKey = (key: string) => {
        const matchInOut = key.match(/ae(\d+)(In|Out)/i);
        if (matchInOut) {
          return {
            number: parseInt(matchInOut[1], 10),
            type: matchInOut[2].toLowerCase(),
            order: 1,
          };
        }

        const matchFuel = key.match(/ae(\d+)_FuelConsumption/i);
        if (matchFuel) {
          return { 
            number: parseInt(matchFuel[1], 10), 
            type: 'fuel', 
            order: 2
          };
        }

        const matchBase = key.match(/ae(\d+)$/i);
        if (matchBase) {
          return {
            number: parseInt(matchBase[1], 10),
            type: 'base',
            order: 1,
          };
        }

        return { number: Infinity, type: '', order: 99 };
      };

      const aVal = parseKey(a.key);
      const bVal = parseKey(b.key);

      if (aVal.number !== bVal.number) return aVal.number - bVal.number;

      if (aVal.order !== bVal.order) return aVal.order - bVal.order;

      if (aVal.type !== bVal.type) {
        if (aVal.type === 'in') return -1;
        if (bVal.type === 'in') return 1; 
      }

      return 0;
    });

    columns = [...columns, ...columnAESorted];
  }

  if (
    columnFlowmeterIds.length ||
    columnRPMPort ||
    columnRPMStarboard ||
    columnRPMCenter ||
    columnAe1Custom ||
    columnAe2Custom ||
    columnAe3Custom
  ) {
    columns.push({
      title: 'Total Fuel Cons. (Liter)',
      dataIndex: 'totalFuelCons',
      key: 'totalFuelCons',
      align: 'center',
      width: 100,
    });
  }

  return columns;
};

const mapOperationModeChildren = (
  prefix: string,
  children: typeof columnChildrenOperationMode,
) =>
  children.map((item) => {
    return {
      ...item,
      align: 'center' as const,
      width: item.width || 100,
      dataIndex: prefix + '_' + capitalizeFirstLetter(item.dataIndex),
      key: prefix + '_' + capitalizeFirstLetter(item.key),
    };
  });

const operationModeSides = [
  { title: 'PORT', key: 'port', clutchKey: 'clutchPort' },
  { title: 'STARBOARD', key: 'starboard', clutchKey: 'clutchStarboard' },
  { title: 'CENTER', key: 'center', clutchKey: 'clutchCenter' },
] as const;

export const generateReportOperationModeColumns = (
  logs: ILogReport,
  source: 'engine' | 'clutch' | 'combined' = 'engine',
) => {
  let columns: TableColumnsType<any> = [
    {
      title: 'Date & time',
      dataIndex: 'dateTime',
      key: 'dateTime',
      width: 150,
      align: 'center',
      fixed: 'left',
    },
  ];

  if (source === 'combined') {
    const engineKeys = getPresentOperationModeKeys(logs.operation_mode, [
      'port',
      'starboard',
      'center',
    ]);
    const clutchKeys = getPresentOperationModeKeys(
      logs.operation_mode,
      CLUTCH_OPERATION_MODE_KEYS,
    );

    operationModeSides.forEach((side) => {
      const children = [
        ...(engineKeys.includes(side.key)
          ? mapOperationModeChildren(side.key, columnChildrenOperationMode)
          : []),
        ...(clutchKeys.includes(side.clutchKey)
          ? mapOperationModeChildren(
              side.clutchKey,
              columnChildrenClutchOperationMode,
            )
          : []),
      ];

      if (!children.length) return;

      columns.push({
        title: side.title,
        key: side.key,
        width: children.length * 100,
        children,
      });
    });

    return columns;
  }

  if (source === 'clutch') {
    const presentKeys = getPresentOperationModeKeys(
      logs.operation_mode,
      CLUTCH_OPERATION_MODE_KEYS,
    );

    clutchOperationModeColumnGroups.forEach((group) => {
      if (!presentKeys.includes(group.key)) return;
      columns.push({
        title: group.title,
        key: group.key,
        width: 400,
        children: mapOperationModeChildren(
          group.key,
          columnChildrenClutchOperationMode,
        ),
      });
    });

    return columns;
  }

  if (Object.hasOwn(logs, 'operation_mode') && logs.operation_mode) {
    const firstKey = Object.keys(logs.operation_mode)[0];

    if (logs.operation_mode[firstKey]) {
      if (logs.operation_mode[firstKey].port) {
        columns.push({
          title: 'PORT',
          key: 'port',
          width: 400,
          children: mapOperationModeChildren('port', columnChildrenOperationMode),
        });
      }
      if (logs.operation_mode[firstKey].starboard) {
        columns.push({
          title: 'STARBOARD',
          key: 'starboard',
          children: mapOperationModeChildren(
            'starboard',
            columnChildrenOperationMode,
          ),
        });
      }
      if (logs.operation_mode[firstKey].center) {
        columns.push({
          title: 'CENTER',
          key: 'center',
          children: mapOperationModeChildren(
            'center',
            columnChildrenOperationMode,
          ),
        });
      }
    }
  }

  return columns;
};
